import React, { useState, useRef, useEffect, useContext, Suspense } from 'react';
import { useDispatch, ReactReduxContext } from 'react-redux';
//import SocialMediaComponent from './heading/SocialMediaComponent';
import { uploadProfileImage } from '../services/actions/actions';
import { Redirect } from 'react-router';
import { FINAL_RESUME, HEADING_LINK, EDUCATION_LINK, NEXT_EDUCATION_LABEL, NEXT_LABEL, NEXT_WORKHISTORY_LABEL, SUMMARY_LINK, WORKHISTORY_LINK, STATE_LIST, POPUP_TYPES, IMAGE_FOLDER_URL, EDITOR_ALL_INONE_LINK, WORKHISTORY_TIPS_LINK } from '../constants/constants';
import ErrorValidator from '../ErrorValidator';
import QuickTips from './common/QuickTips';
// import {SAVE_RESUME} from '../constants/constants'
import Portfolio from './heading/Portfolio';
import { useResume } from '../context/ResumeContext';
import { usePopup } from '../context/PopupContext';
import { setBodyHeight } from '../helper';
import WpAPI from '../WpApi';
const EditorHeading = (props) => {
  const { store } = useContext(ReactReduxContext);
  // const {resume} = useContext(ResumeContext);
  const ddRef = useRef();
  const {
    resume: {
      heading,
      // socials,
      portfolio,
      enabled_tabs,
    },
    handlers: {
      onValueChange,
      updateResumePreview,
      nuteralizeNextClick
    },
    next_clicked,
    next_label,
    toggleProfilePicture
  } = useResume();

  const confirmbox = usePopup();

  const dispatch = useDispatch();
  // const { heading, socials, portfolio } = props.data;
  /**
   * Commented out these validations. 
   * Reference GitLab#746 - 3rd Point.
   * David asked us to remove the validations
   *
  const validatorSet = { 
    fname: { empty: "Please Enter Your First Name" },
    lname: { empty: "Please Enter Your Last Name" },
    profession: { empty: "Please Enter a Job Title" },
    address: {
      other1: {
        msg: "Please Enter Your Address",
        validator: val => !(val.length)
      }

    },
    city: {
      other1: {
        msg: "Please Enter Your City",
        validator: val => !(val.length)
      }
    },
    state: {
      other1: {
        msg: "Please Enter Your State",
        validator: val => !(val.length)
      }
    },
    country: {
      other1: {
        msg: "Please Enter Your Country",
        validator: val => false
      }
    },
    zipcode: {
      // empty: "Please Enter Zip Code",
      other1: {
        msg: "Please Enter Valid Zip",
        validator: val => !(!val.length || (val.length && (/^[a-z0-9][a-z0-9\- ]{0,14}[a-z0-9]$/i.test(val))))
      }
    },
    phone: {
      //empty: "Please Enter Your Phone Number",
      other1: {
        msg: "Please Enter a Valid Phone Number",
        validator: val => {
          const phonereg = /^\+?[0-9\s\(\)-]{9,20}$/
          //Skip validation for blank
          return val.length ? !phonereg.test(val) : false;
        }
      }
    },
    email: {
      empty: "Please Enter Your Email Address",
      other1: {
        msg: "Please Enter a Valid Email Address",
        validator: val => !(/\S+@\S+\.\S+/.test(val))
      }
    },
  };
  **/

  const validatorSet = {
    fname: { 
      other1: {
        msg: "Please Enter Your First Name",
        validator: val => false
      } 
    },
    lname: { 
      other1: {
        msg: "Please Enter Your Last Name",
        validator: val => false
      }
    },
    profession: { 
      other1: {
        msg: "Please Enter a Job Title",
        validator: val => false
      }
    },
    address: {
      other1: {
        msg: "Please Enter Your Address",
        validator: val => false
      }

    },
    city: {
      other1: {
        msg: "Please Enter Your City",
        validator: val => false
      }
    },
    state: {
      other1: {
        msg: "Please Enter Your State",
        validator: val => false
      }
    },
    country: {
      other1: {
        msg: "Please Enter Your Country",
        validator: val => false
      }
    },
    zipcode: {
      other1: {
        msg: "Please Enter Valid Zip",
        validator: val => {
          const zipreg = /^[a-z0-9][a-z0-9\- ]{0,14}[a-z0-9]$/i
          return (val.length ? !zipreg.test(val) : false);
        }
      }
    },
    phone: {
      other1: {
        msg: "Please Enter Your Phone Number",
        validator: val => false
      }
    },
    email: {
      empty: "Please Enter Your Email Address",
      other1: {
        msg: "Please Enter a Valid Email Address",
        validator: val => !(/\S+@\S+\.\S+/.test(val))
      }
    }
  };
  
  const validatorsSet2 = {
    // label: { empty: "Please Enter Label For Link" },
    link: {
      other: {
        msg: "Invalid URL",
        validator: val => {
          // return !(/^(https?:\/\/)/.test(val) || /^(www\.)/.test(val))
          return false;
        },
      }
    }

  }

  //For error validations
  const portfolioValidators = {}
  //For error validations
  const vObj = new ErrorValidator(validatorSet)
  //Style error
  const errorStyle = { color: "red", fontSize: "10px" };
  //Show error using this state
  const [error, setError] = useState({});
  //Flag is Do next redirect
  const [redirectNext, setredirectNext] = useState(false);

  const [openList, setOpenList] = useState(false);
  //Component asked to redirect, first validate
  const [redirectCall, setredirectCall] = useState(false);
  const [uploaded, setuploaded] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState('');
  const [blabel, setblabel] = useState('Upload Photo');
  const [imageName, setImageName] = useState(heading.hasOwnProperty('profile_picture') ? heading.profile_picture : '');

  const [checkField, setCheckField] = useState('');
  const [showToolTip, setShowToolTip] = useState(false);
  const [showNameInput, setShowNameInput] = useState(false);
  const [editName, setEditName] = useState(false);

  const toggleDropDown = () => {
    setOpenList(!openList);
  }

  const update = (input) => {
    const new_personal_detail = { ...heading, ...input, completed: false };
    updateResumePreview({ heading: new_personal_detail, current_tab: 'heading' });
  };
  //Quick edit mode
  const QEM = enabled_tabs.includes('completed')
  const label = (l) => QEM ? NEXT_LABEL : l
  const rURL = (u) => QEM ? FINAL_RESUME : u
  const nextClicked = () => {
    // debugger
    if (next_clicked && validateForm()) {
      //Set for next page
      nuteralizeNextClick({ next_label: label(NEXT_WORKHISTORY_LABEL) }, true, QEM ? '' : 'work_history')
      // browser issue, page does not get opened to the top
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      WpAPI.saveResmeProgress({
        email: heading.email,
        name: `${heading.fname} ${heading.lname}`,
        phone: heading.phone
        
      });
      return true;
    } else {
      //Set for own page
      if (next_clicked || next_label != label(NEXT_WORKHISTORY_LABEL)) {
        //Always run for next click and self label not matched
        nuteralizeNextClick({
          next_label: label(NEXT_WORKHISTORY_LABEL),
        });
      }
      return false;
    }
  };

  const errorExists = () => {
    let anyerror = [];
    Object.keys(error).map((key) => {
      if (error[key] != "") anyerror.push(key);
    });
    return anyerror.length > 0 ? true : false;
  };

  const validateForm = () => {
    if (redirectCall) {
      let h = vObj.validateFields(heading), pv = validatePortfolioForm()
      // let v = pv === true ? {...h} : { ...h, ...pv }
      let v = { ...h, ...pv }
      if (Object.keys(v).length == 0) {
        return true;
      } else {
        setError({ ...v });
        return false;
      }
    } else {
      return false;
    }
  }
  const validatePortfolioForm = () => {
    let v = {}
    //validate for each softwares, store validate in object
    portfolio && Object.keys(portfolio.set).map(key => {
      if (!portfolioValidators.hasOwnProperty(key)) portfolioValidators[key] = new ErrorValidator(validatorsSet2)
      const er = portfolioValidators[key].validateFields(portfolio.set[key])
      if (Object.keys(er).length) v[key] = er
    })
    return v
    // if (Object.keys(v).length == 0) {
    //   return true;
    // } else return v;
  }

  const removeError = (e) => {
    setError({ ...error, [e.target.name]: "" });
  }

  const fieldFocus = e => {
    setCheckField(e.target.name);
    removeError(e);
    update({ validated: { ...heading.validated, [e.target.name]: false } })
  }

  const fieldBlur = e => {
    setCheckField('');
    // const er = validateFields(e.target.name)
    const er = vObj.validateFields(e.target.value, e.target.name)
    if (!Object.keys(er).length) {
      update({ validated: { ...heading.validated, [e.target.name]: true } })
    } else setError({ ...error, ...er });
  }


  useEffect(() => {
    if (nextClicked()) setredirectNext(true);
    else setredirectNext(false);
    setredirectCall(false);

  }, [redirectCall]);
  useEffect(() => {
    //browser issue, page does not get opened to the top
    window.scrollTo(0, 0);
    confirmbox.configurePopup(POPUP_TYPES);
    const body = document.querySelector('body');
    if (body) {
      body.style.height = '100%';
    }
  }, []);
  if (next_clicked && !redirectCall) setredirectCall(true);
  if (redirectNext) {
    history.pushState(null, HEADING_LINK);
    return <Redirect to={rURL(WORKHISTORY_TIPS_LINK)} />
  }

  
  //Dont allow render allinone editor in case resume is not completed
  // if(!props.hasOwnProperty('tabOpened') && heading.fname.length && enabled_tabs.indexOf('completed') > -1) return <Redirect to={EDITOR_ALL_INONE_LINK} />

  const processing = (s) => s ? setblabel('Processing...') : setblabel('Upload Photo')

  const updateImage = (f) => {
    processing(true);
    if (f[0] !== undefined) {
      const uploadedImage = f[0];
      if (uploadedImage.size > 2097152) {
        setErrorMsg('The image exceeds the maximum allowed size (2MB). Please try a smaller image.');
        // setTimeout(() => {
        //   setErrorMsg('');
        // }, 5000);
        processing(false);
        return false;
      } else {
        (dispatch(uploadProfileImage(f[0])).then(res => {
          if (res.msg == 'success') {
            processing(false);
            setImageName(res.name);
          }
        }).catch(error => {
          console.log('got en error', error);
          setErrorMsg(error);
          setTimeout(() => {
            setErrorMsg('');
          }, 5000);
          processing(false);
        }))
      }
    }
  }
  const showTabOpenCloseIcon = () => (
    props.hasOwnProperty('tabOpened') ?
      <span className="open-close-btn blue" onClick={() => {
        props.tabClicked('heading', false);
        setShowNameInput(false);
        setBodyHeight();
      }}>
        {props.tabOpened ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
        </span> : ''
  )
  const getShortName = (fname, lname) => {
    const a = fname ? fname.charAt(0) : "";
    const b = lname ? lname.charAt(0) : "";
    return a + b;
  };

  return (
    <div className="editor-block-inner">
      {props.splash}
      <div className="editor-area blue-line">
        <div className="form-heading">
          {/* <div className="on-off-btn disabled">
            <span><i></i></span>
          </div> */}
          {props.hasOwnProperty('tabClicked') 
          ? <><div className="heading" onClick={() => {
            if(!showNameInput){
              props.tabClicked('heading', editName);
              setEditName(false);
            }
          }}>
            {showNameInput 
            ? '' 
            : <>
                <h1>
                {heading.name ?? `Contact Information`} {
                    props?.tabOpened && props.tabOpened 
                    ? <i className="icon-pencil" onMouseOver={() => setEditName(true)} onClick={() => {
                      setShowNameInput(true);
                      props.tabClicked('heading', editName);
                    }}></i>
                    : ''
                  }
                </h1>
              </>
            }
            {showNameInput 
            ? <input
              type="text"
                className="edit-block-name"
              name="name"
              value={heading.name ?? `Contact Information`}
              onChange={(e) => {
                props.tabClicked('heading', true)
                update({ name: e.target.value });
              }}
              onFocus={(e) => fieldFocus(e)}
              onBlur={(e) => {
                fieldBlur(e);
                setShowNameInput(false)
              }
              //onMouseOut={(e) => setShowNameInput(false)
            }
            />
            : '' }
            {error.name && (
              <span style={errorStyle}>{error.name}</span>
            )}
            <p className='heading-para'>Enter your basic personal details, including contact information, to get started.</p>
          </div></> 
          : <div className="heading" style={{cursor: "default"}}>
              <h1>{heading.name ?? `Contact Information`}</h1>
              <p className='heading-para'>Enter your basic personal details, including contact information, to get started.</p>
            </div>
          }
          {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="quick-tips">
            <span
              onClick={() => {
                setShowToolTip(!showToolTip);
              }}><i className="icon-lightbulb-on"></i>Quick Tips</span>
            {showToolTip ? <QuickTips section='heading' setShowToolTip={(showToolTip) => { setShowToolTip(showToolTip) }} /> : ''}
          </div>}
          {showTabOpenCloseIcon()}
        </div>
        {(!props.hasOwnProperty('tabOpened') || props?.tabOpened) && <div className="editor-form-wrap">
          <div className="editor-form">
          <div className="form-row column-2">
            <div className="field-wrap">
              {/* <label htmlFor="fname" className={`label${checkField == 'fname' ? ' label-focus': '' }`}>First Name</label> */}
              <input
                placeholder="First Name"
                type="text"
                className="validate"
                name="fname"
                value={heading.fname}
                onChange={(e) => {
                  update({ fname: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.fname && <span style={errorStyle}>{error.fname}</span>}
            </div>
            <div className="field-wrap">
              {/* <label htmlFor="lname" className={`label${checkField == 'lname' ? ' label-focus': '' }`}>Last Name</label> */}
              <input
                placeholder="Last Name"
                type="text"
                className="validate"
                name="lname"
                value={heading.lname}
                onChange={(e) => {
                  update({ lname: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.lname && <span style={errorStyle}>{error.lname}</span>}
            </div>
          </div>
          <div className="form-row">
            <div className="field-wrap">
              {/* <label htmlFor="profession" className={`label${checkField == 'profession' ? ' label-focus': '' }`}>Job Title</label> */}
              <input
                placeholder="Job Title"
                type="text"
                className="form-input validate"
                name="profession"
                value={heading.profession}
                onChange={(e) => {
                  update({ profession: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.profession && (
                <span style={errorStyle}>{error.profession}</span>
              )}
            </div>
          </div>
          <div className="form-row column-2">
            <div className="field-wrap">
              {/* <label htmlFor="address" className={`label${checkField == 'address' ? ' label-focus': '' }`}>Address 1</label> */}
              <input
                placeholder="Address 1"
                type="text"
                className="validate"
                name="address"
                value={heading.address}
                onChange={(e) => {
                  update({ address: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />

              {error.address && (
                <span style={errorStyle}>{error.address}</span>
              )}
            </div>
            <div className="field-wrap">
              {/* <label htmlFor="city" className={`label${checkField == 'city' ? ' label-focus': '' }`}>Address 2</label> */}
              <input
                placeholder="Address 2"
                type="text"
                className="validate"
                value={heading.city}
                name="city"
                onChange={(e) => {
                  update({ city: e.target.value });
                }}
                onFocus={(e) => fieldFocus(e)}
                onBlur={(e) => fieldBlur(e)}
              />
              {error.city && <span style={errorStyle}>{error.city}</span>}
            </div>
              {/*<div className="field-wrap">
                <label htmlFor="zipcode" className={`label${checkField == 'zipcode' ? ' label-focus': '' }`}>Zip Code</label>
                <input
                  type="text"
                  className="validate"
                  name="zipcode"
                  value={heading.zipcode}
                  onChange={(e) => {
                    update({ zipcode: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                {error.zipcode && <span style={errorStyle}>{error.zipcode}</span>}
                </div>*/}
            </div>
            {/*<div className="form-row column-2">
              <div className="field-wrap">
                <label className={`label${checkField == 'state' ? ' label-focus': '' }`}>State</label>
                <div className="input-dd">
                  <input
                    className="current-value"
                    type="text"
                    name="state"
                    onChange={e => update({ state: e.target.value })}
                    value={heading.state}
                    onFocus={(e) => fieldFocus(e)}
                    onBlur={(e) => fieldBlur(e)}
                  />
                  {error.state && <span style={errorStyle}>{error.state}</span>}
                </div>
              </div>
              <div className="field-wrap">
                <label htmlFor="country" className={`label${checkField == 'country' ? ' label-focus': '' }`}>Country</label>
                <input
                  type="text"
                  className="validate"
                  name="country"
                  value={heading?.country ?? ''}
                  onChange={(e) => {
                    update({ country: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                //{error.zipcode && <span style={errorStyle}>{error.zipcode}</span>}
              </div>
                </div>*/}
            <div className="form-row column-2">
              <div className="field-wrap">
                {/* <label htmlFor="phone" className={`label${checkField == 'phone' ? ' label-focus': '' }`}>Phone</label> */}
                <input
                  placeholder="Phone"
                  type="text"
                  className="validate"
                  name="phone"
                  value={heading.phone}
                  onChange={(e) => {
                    update({ phone: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                {error.phone && <span style={errorStyle}>{error.phone}</span>}
              </div>
              <div className="field-wrap">
                {/* <label className={`label${checkField == 'email' ? ' label-focus': '' }`}>Email Address</label> */}
                <input
                  placeholder="Email Address"
                  type="text"
                  className="validate"
                  name="email"
                  value={heading.email}
                  onChange={(e) => {
                    update({ email: e.target.value });
                  }}
                  onFocus={(e) => fieldFocus(e)}
                  onBlur={(e) => fieldBlur(e)}
                />
                {error.email && <span style={errorStyle}>{error.email}</span>}
                <p className='email-disclaimer'>By creating a resume, you agree to receive emails — unsubscribe anytime.</p>
              </div>
            </div>
          </div>
        <Portfolio
          // portfolio={portfolio}
          // sociallinks={socials}
          // savePortfolio={savePortfolio}
          validatatorObj={portfolioValidators}
          error={error}
          setError={setError}
          validatorsSet2={validatorsSet2}
        />
        </div>}
      </div>
    </div>
  );
}

export default EditorHeading;